import React from 'react'
import clsx from 'clsx'
import NextImage from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Text } from '@wartek-id/text-v1'

import type { TPraktikKinerjaItem } from 'types/kinerja-ps-pegawai'

type CardIndicatorProps = {
  isActive: boolean
  isDisabled?: boolean
  onClick?: () => void
} & TPraktikKinerjaItem

const CardIndicator = ({
  nama,
  keterangan,
  iconUrl,
  isActive,
  isDisabled,
  onClick,
}: CardIndicatorProps) => {
  const clickHandler = () => {
    if (isDisabled) return

    onClick?.()
  }
  return (
    <button
      data-testid="praktik-kinerja-selection-item"
      className={clsx(
        'p-6 border rounded-md border-subdued text-left w-full',
        isActive && 'border-interactive-default bg-surface-selected-default',
        isDisabled && 'cursor-default'
      )}
      onClick={clickHandler}
    >
      <div className="flex space-x-6">
        {isActive && (
          <Icon color="success" fontSize="lg">
            check
          </Icon>
        )}

        {Boolean(iconUrl) && (
          <div className="flex-none">
            <NextImage src={iconUrl} width="64px" height="64px" />
          </div>
        )}

        <div className="space-y-1">
          <Text variant="heading-sm" className="flex-1">
            {nama}
          </Text>
          <Text className="flex-1" color="subdued">
            <div
              dangerouslySetInnerHTML={{
                __html: keterangan.replace(/\\n/g, '<br />'),
              }}
            />
          </Text>

          <div className="pt-4">
            {!isDisabled && (
              <Button
                color={isActive ? 'black' : 'white'}
                size="sm"
                className={clsx('!px-12', isActive && '!px-8')}
              >
                {isActive ? (
                  <div className="flex items-center space-x-1">
                    <Icon color="inverse">check</Icon>
                    <span>Dipilih</span>
                  </div>
                ) : (
                  'Pilih'
                )}
              </Button>
            )}
          </div>
        </div>
      </div>
    </button>
  )
}

export default CardIndicator
